module.exports = __webpack_public_path__ + "img/delete.fd895727.svg";